import "./FeaturedProducts.scss";
import Card from "../../components/Card/Card";
import { useEffect, useState } from "react";
import axios from "axios";
import Loading from "../loading/Loading";

const FeaturedProducts = ({ type }) => {
  const [selectType, setSelectType] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!type) return;

    const getType = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`/get-type?type=${type}`);
        // Filter out out-of-stock and sort by price ascending
        const filteredSorted = response.data
          .filter((item) => !item.outofstock) // hide out-of-stock
          .sort((a, b) => a.price - b.price)
          .slice(0, 20); // lowest to highest
        setSelectType(filteredSorted);
      } catch (err) {
        setError(err.message || "Something went wrong");
      } finally {
        setLoading(false);
      }
    };

    getType();
  }, [type]);

  return (
    <div>
      <div className="___heading_main">
        <h3>
          Top Selling <em>products</em>
        </h3>
      </div>
      <div className="f_wrp">
        <div className="f_wrp_in">
          {error ? (
            <p>{error}</p>
          ) : loading ? (
            <p>
              <Loading />
            </p>
          ) : (
            selectType?.map((item) => (
              <Card item={item} key={item._id} state={{ id: item._id }} />
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default FeaturedProducts;
